<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                <b-breadcrumb-item href="#" active>Awards and Recognition</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">

          <div id="Fin1">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">Awards and Recognition</h1>
              </b-col>

           </b-row>


             <div id="">
                 <p class="">
                   <b-img src="../assets/esuvidha_award.jpeg" style="width:75%"/>
                 </p>
             </div>
             <p class="content">
             At a time when privately owned power utilities are the pioneers in implementing state of the art technical innovations across
             the power sector, Assam Power Distribution Company Limited (APDCL), a public utility, has been awarded the Platinum Award  in
             the category "Adoption of Emerging Technology by a Utility" for the project " Implementation of Artificial Intelligence (AI) Based
             Meter Reading Solution"  in the event "Indian Smart Utility Week 2021" organised by ISGF( Indian Smart Grid Forum). The award was
             received by Shri Rakesh Agarwala , IAS , Managing Director, APDCL on behalf of the Organisation in a ceremony held at the National
             Capital on 5th March, 2021. The evaluation for the award was done by a distinguished panel comprising of Mr. P Uma Shankar, former
             Power Secretary, Government of India, Mr. V. Subramanian, former Secretary, MNRE, Government of India, Mrs. Padmaja Ruparel, Co-Founder
             and President, Indian Angel  Network and Mr. B.P.Singh, Former Member, Delhi Electricity Regulatory Commission.
             <br><br>
             85% of APDCL’s consumer base is in rural areas. Accurate meter reading of rural consumers have always been a challenge for APDCL.
              Via the AI based meter reading solution, APDCL meter readers use the Artificial Intelligence based e-suvidha App to capture consumers’
               meter readings without any human intervention. This results in correct meter reading collection and proper billing leading to increase
                in billing efficiency as well as decrease in the AT&C losses of APDCL.
                 <br><br>
             The solution has been in operation across APDCL since 1st January, 2021. It is expected that implementation of the Artificial
             Intelligence based meter reading solution will bring about a financial turnaround for APDCL.

             </p>
          </div>
          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'

export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    }

}
</script>

<style scoped="true">
li{
  padding:0;
}
body{
    overflow-y:hidden;
}
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}
.content{
  text-align: justify;
  line-height: 1.5rem;
  font-size:0.9rem;
}
.cntnt{
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding:10px 30px 10px 30px;
}
table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
</style>
